import { Component, OnInit, NgModule } from '@angular/core';
import { HttpClient, HttpRequest } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators, FormArray, FormControl } from '@angular/forms';
import { Injectable } from '@angular/core';
import {MomentDateAdapter} from '@angular/material-moment-adapter';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
import * as _moment from 'moment';
import {Observable, of} from 'rxjs';
import {delay, map, startWith} from 'rxjs/operators';
import { stringify } from 'querystring';
import { DomSanitizer, SafeResourceUrl, SafeUrl } from '@angular/platform-browser';
import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';
import {AppComponent} from '../../app.component';
//import { AlertComponent } from '../../alertpopup/_alert/alert';
import { AlertService } from '../../alertpopup/_alert';
declare var $: any;
export const MY_FORMATS = {
  parse: { dateInput: 'DD-MMM-YYYY' },
  display: {
    dateInput: 'DD-MMM-YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMM YYYY',
  },
};
export interface Insertnoticecase {
  id: Int16Array;
  refno: string;
  Type: string;
  IsSent: any;
  NoticeDt: string;
  TargetDt: string;
  DueDt: string;
  ManagerID: Int16Array;
  LeaderID: Int16Array;
  recEnable: Int16Array;
  recUser: Int16Array;
  recAddUser: Int16Array;
  fillingPartyName: string;
  OppositePartyName: string;
  ManagerPreID: any;
  LeaderPreID: any;
  }
export interface fillingOppositeParty {
  ID: string;
  Name: string;
  Mobile: string;
  State: string;
  City: string;
  typ: string;
}
export interface INoticeProduct {
  ID: number;
  Remarks: string;
  ProductName: string;
  ProductCode: string;
  ProductID: string;
}
export interface Section {
  hdID: string;
  MainDescr: string;
}
@Injectable({ providedIn: 'root'})
@Component({
    selector: 'app-create-noticecase',
    templateUrl: './create-noticecase.component.html',
    styleUrls: ['./create-noticecase.component.css'],
    providers: [
        // `MomentDateAdapter` can be automatically provided by importing `MomentDateModule` in your
        // application's root module. We provide it at the component level here, due to limitations of
        // our example generation script.
        { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
        { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
    ],
    standalone: false
})
export class CreateNoticecaseComponent implements OnInit {
  TypeHeader: string;
  Type: string;
  Sent: string;
  Received: string;
  id: any;
  Manager: any;
  Leader: any;
  User: any;
  url: string;
  pageurl: string;
  RefNo: string;
  addFormNotice: FormGroup;
  getdata: string;
  numb: any;
  DateofNotice: string;
  DueDate: string;
  LastDate: string;
  DateofReceiving: string;
  TargetDate: string;
  minDate = new Date(1990, 0, 1);
  maxDate = new Date(2090, 0, 1);
  NoticeCaseData: any;
  DisplayExistNotice: string;
  selectedFillingParty = [];
  selectedOppositeParty = [];
  FillingOppoParty: fillingOppositeParty[] = [];
  filteredFillingParty: fillingOppositeParty[] = [];
  filteredOppositeParty: fillingOppositeParty[] = [];
  ContactList: fillingOppositeParty[] = [];
  DisplaySaveNoticeButton: string;
  FetchExistingFillingParty: any;
  FetchExistingOppositeParty: any;
  HeaderButtonCaption: string;
  editable: boolean;
  clicked: boolean;
  DownloadURL: string;
  RightsID: string;
  RouteUserMaster: string;
  HideContent: string;
  ManagerPreID: any;
  LeaderPreID: any;
  options = {
    autoClose: true,
    keepAfterRouteChange: false
};
  CaptionJurisdiction: any;
  CaptionShortName: any;
  CaptionExposurAmount: any;
  CaptionDateofReceiving: any;
  JudgeName: any;
  PoliceStation: any;
  InvestigatingOfficer: any;
  FIRNo: any;
  str1: any;
  AddFollowupLink: any;
  captionType: any;
  captionCaseCode: any;
  captionManager: any;
  captionCategory: any;
  captionSubCategory: any;
  captionProject: any;
  captionLeader: any;
  captionDateofFilingNotice: any;
  captionDateofFilingCase: any;
  captionState: any;
  captionStatus: any;
  captionDateofReceivingNotice: any;
  captionDateofReceivingCase: any;
  captionCity: any;
  captionSeriousness: any;
  captionTargetDate: any;
  captionRegion: any;
  captionBranch: any;
  captionNextDateofHearing: any;
  captionDateofCase: any;
  captionDateofNotice: any;
  captionSection: any;
  captionCompany: any;
  captionDepartment: any;
  captionBench: any;
  captionLawyer: any;
  captionCourtNumber: any;
  captionCurrency: any;
  captionRecoveryAmount: any;
  captionNegotiateAmount: any;
  captionBalanceAmount: any;
  captionFIRDate: any;
  captionAgency: any;
   captionFilingParty: any;
  captionOppositeParty: any;
   constructor(private router: Router, private http: HttpClient, private formBuilder: FormBuilder, private sanitization: DomSanitizer, public datepipe: DatePipe,protected alertService: AlertService ) {
     this.url = AppComponent.baseURL;
     this.DownloadURL = AppComponent.DownloadURL;
   }
  ngOnInit() {
    this.ManagerPreID = 0 ;
    this.LeaderPreID = 0 ;
    this.RightsID = localStorage.getItem('UserRight');
    this.pageurl = this.router.url;
    let pagehead = this.pageurl.split('/');
    this.getCaptionData();
    this.RouteUserMaster = this.RightsID.includes('202040000') || this.RightsID.includes('202040001') || this.RightsID.includes('202040021') ? '/user-master' : '/module/0';
    this.FetchFillingOppositePartyList();
    this.getMasterData();
    this.id = pagehead[3];

    this.DisplayExistNotice = "!isHidden";
    this.DisplaySaveNoticeButton = "submit";
    this.HeaderButtonCaption = "Create";
    if (this.id > 0) {
      this.HeaderButtonCaption = "Update";
      this.DisplayExistNotice = "";
      this.DisplaySaveNoticeButton = "submit";
      this.fetchNoticeCaseData();
    }
    if (pagehead[2] == "notice" || pagehead[2] == "Notice") {
      this.TypeHeader = 'Notice';
      this.Type = 'Notice';
      this.Sent = 'Sent';
      this.Received = 'Received';
      if (this.RightsID.includes('202030001') || this.RightsID.includes('202030021') || this.RightsID.includes('202030000')) {
      } else {
        window.location.href = "module/0";
      }
    } else if (pagehead[2] == 'case' ||  pagehead[2] == "Case" ) {
      this.TypeHeader = 'Case';
      this.Type = 'Case';
      this.Sent = 'Filled by Us';
      this.Received = 'Against Us1';
      if (this.RightsID.includes('202032001') || this.RightsID.includes('202032021') || this.RightsID.includes('202032000')) {
      } else {
        window.location.href = "module/0";
      }
    }

    // Set Validation of Add Notice / Case Form on Header Part
    this.addFormNotice = this.formBuilder.group({
      Notice: [''], Manager: [null, Validators.required], DateofNotice: ['', Validators.required], RefNo: ['', Validators.required],
      Leader: ['', Validators.required], TargetDate: ['',Validators.required], DueDate: ['',Validators.required], OppositePartyName: [null, Validators.required], fillingPartyName: [null, Validators.required],
    });

    // Set By Default Value on Header Part
    this.addFormNotice.patchValue({
        Notice: "1" , Manager: null, Leader: null });

    // React to changes
    this.addFormNotice.get('fillingPartyName')?.valueChanges.subscribe(val => {
      this.selectedFillingParty = val || [];
      this.updateFilters();
    });

    this.addFormNotice.get('OppositePartyName')?.valueChanges.subscribe(val => {
      this.selectedOppositeParty = val || [];
      this.updateFilters();
    });
 }
 getCaptionData() {
    let pagehead = this.pageurl?.split('/');

       this.http.get(this.url + 'Dashboard/CaptionData?id=')
      .subscribe((data:any) => {
        console.log(JSON.parse(data));
        for (var val of JSON.parse(data.toString())) {

          if (val['MainDescr'].toUpperCase() == pagehead[2].toUpperCase() && val['SubDescr'] == 'Jurisdiction/ Court Name') {
            this.CaptionJurisdiction = val['SelectedValue'];
          }
          if (val['MainDescr'].toUpperCase() == pagehead[2].toUpperCase() && val['SubDescr'] == 'Short Name') {
            this.CaptionShortName = val['SelectedValue'];
          }

          if (val['MainDescr'].toUpperCase() == pagehead[2].toUpperCase() && val['SubDescr'] == 'Exposure Amount') {
            this.CaptionExposurAmount = val['SelectedValue'];
          }

          if (val['MainDescr'].toUpperCase() == pagehead[2].toUpperCase() && val['SubDescr'] == 'Date of Receiving') {
            this.CaptionDateofReceiving = val['SelectedValue'];
          }

          // Change for vatika (Renaming Column Name)  <!-- Add for valika by Ankur-->
          if (val['MainDescr'].toUpperCase() == pagehead[2].toUpperCase() && val['SubDescr'] == 'Ref No. *') {
            this.RefNo = val['SelectedValue'].replace("*", '');
          }
          if (val['MainDescr'].toUpperCase() == pagehead[2].toUpperCase() && val['SubDescr'] == 'Ref No. *') {
            this.RefNo = val['SelectedValue']
          }
          if (val['MainDescr'].toUpperCase() == pagehead[2].toUpperCase() && val['SubDescr'] == 'Judge Name') {
            this.JudgeName = val['SelectedValue'];
          }
          if (val['MainDescr'].toUpperCase() == pagehead[2].toUpperCase() && val['SubDescr'] == 'Police Station') {
            this.PoliceStation = val['SelectedValue'];
          }
          if (val['MainDescr'].toUpperCase() == pagehead[2].toUpperCase() && val['SubDescr'] == 'Investigating Officer Name') {
            this.InvestigatingOfficer = val['SelectedValue'];
          }
          if (val['MainDescr'].toUpperCase() == pagehead[2].toUpperCase() && val['SubDescr'] == 'Last Date to Respond') {
            this.LastDate = val['SelectedValue'];
          }
          if (val['MainDescr'].toUpperCase() == pagehead[2].toUpperCase() && val['SubDescr'] == 'Due Date') {
            this.DueDate = val['SelectedValue'];
          }
          if (val['MainDescr'].toUpperCase() == pagehead[2].toUpperCase() && val['SubDescr'] == 'FIR No.') {
            this.FIRNo = val['SelectedValue'];
          }
          if (val['MainDescr'].toUpperCase() == pagehead[2].toUpperCase() && val['SubDescr'] == 'Company/Department') {
            this.str1 = val['SelectedValue'];
          }

          if (val['MainDescr'].toUpperCase() == pagehead[2].toUpperCase() && val['SubDescr'] == 'Add To Follow UP') {
            this.AddFollowupLink = val['SelectedValue'];
          }

          if (val['MainDescr'].toUpperCase() == pagehead[2].toUpperCase() && val['SubDescr'] == 'Type') {
            this.captionType = val['SelectedValue'];
          }

          // Case Code
          if (val['MainDescr'].toUpperCase() == pagehead[2].toUpperCase() && val['SubDescr'] == 'Case Code') {
            this.captionCaseCode = val['SelectedValue'];
          }
          // Manager
          if (val['MainDescr'].toUpperCase() == pagehead[2].toUpperCase() && val['SubDescr'] == 'Manager') {
            this.captionManager = val['SelectedValue'];
          }
          // Category
          if (val['MainDescr'].toUpperCase() == pagehead[2].toUpperCase() && val['SubDescr'] == 'Category') {
            this.captionCategory = val['SelectedValue'];
          }
          // Sub Category
          if (val['MainDescr'].toUpperCase() == pagehead[2].toUpperCase() && val['SubDescr'] == 'Sub Category') {
            this.captionSubCategory = val['SelectedValue'];
          }
          // Project
          if (val['MainDescr'].toUpperCase() == pagehead[2].toUpperCase() && val['SubDescr'] == 'Project') {
            this.captionProject = val['SelectedValue'];
          }
          // Leader
          if (val['MainDescr'].toUpperCase() == pagehead[2].toUpperCase() && val['SubDescr'] == 'Leader') {
            this.captionLeader = val['SelectedValue'];
          }
          // Date of filing notice
          if (val['MainDescr'].toUpperCase() == pagehead[2].toUpperCase() && val['SubDescr'] == 'Date of filing notice') {
            this.captionDateofFilingNotice = val['SelectedValue'];
          }
          // Date of filing case
          if (val['MainDescr'].toUpperCase() == pagehead[2].toUpperCase() && val['SubDescr'] == 'Date of filing case') {
            this.captionDateofFilingCase = val['SelectedValue'];
          }
          // State
          if (val['MainDescr'].toUpperCase() == pagehead[2].toUpperCase() && val['SubDescr'] == 'State') {
            this.captionState = val['SelectedValue'];
          }
          // Status
          if (val['MainDescr'].toUpperCase() == pagehead[2].toUpperCase() && val['SubDescr'] == 'Status') {
            this.captionStatus = val['SelectedValue'];
          }
          // Date of Receiving Notice
          if (val['MainDescr'].toUpperCase() == pagehead[2].toUpperCase() && val['SubDescr'] == 'Date of Receiving Notice') {
            this.captionDateofReceivingNotice = val['SelectedValue'];
          }
          // Date of Receiving Case
          if (val['MainDescr'].toUpperCase() == pagehead[2].toUpperCase() && val['SubDescr'] == 'Date of Receiving Case') {
            this.captionDateofReceivingCase = val['SelectedValue'];
          }
          // City
          if (val['MainDescr'].toUpperCase() == pagehead[2].toUpperCase() && val['SubDescr'] == 'City') {
            this.captionCity = val['SelectedValue'];
          }
          // Seriousness
          if (val['MainDescr'].toUpperCase() == pagehead[2].toUpperCase() && val['SubDescr'] == 'Seriousness') {
            this.captionSeriousness = val['SelectedValue'];
          }
          // Target Date
          if (val['MainDescr'].toUpperCase() == pagehead[2].toUpperCase() && val['SubDescr'] == 'Target Date') {
            this.captionTargetDate = val['SelectedValue'];
          }
          // Region 
          if (val['MainDescr'].toUpperCase() == pagehead[2].toUpperCase() && val['SubDescr'] == 'Region') {
            this.captionRegion = val['SelectedValue'];
          }
          // Branch
          if (val['MainDescr'].toUpperCase() == pagehead[2].toUpperCase() && val['SubDescr'] == 'Branch') {
            this.captionBranch = val['SelectedValue'];
          }
          // Next Date of Hearing
          if (val['MainDescr'].toUpperCase() == pagehead[2].toUpperCase() && val['SubDescr'] == 'Next Date of Hearing') {
            this.captionNextDateofHearing = val['SelectedValue'];
          }
          // Date of Case
          if (val['MainDescr'].toUpperCase() == pagehead[2].toUpperCase() && val['SubDescr'] == 'Date of Case') {
            this.captionDateofCase = val['SelectedValue'];
          }
          // Date of Notice
          if (val['MainDescr'].toUpperCase() == pagehead[2].toUpperCase() && val['SubDescr'] == 'Date of Notice') {
            this.captionDateofNotice = val['SelectedValue'];
          }
          // Section 
          if (val['MainDescr'].toUpperCase() == pagehead[2].toUpperCase() && val['SubDescr'] == 'Section') {
            this.captionSection = val['SelectedValue'];
          }
          // Company
          if (val['MainDescr'].toUpperCase() == pagehead[2].toUpperCase() && val['SubDescr'] == 'Company') {
            this.captionCompany = val['SelectedValue'];
          }
          // Department
          if (val['MainDescr'].toUpperCase() == pagehead[2].toUpperCase() && val['SubDescr'] == 'Department') {
            this.captionDepartment = val['SelectedValue'];
          }
          //Bench No
          if (val['MainDescr'].toUpperCase() == pagehead[2].toUpperCase() && val['SubDescr'] == 'Bench No') {
            this.captionBench = val['SelectedValue'];
          }
          // Lawyer Name
          if (val['MainDescr'].toUpperCase() == pagehead[2].toUpperCase() && val['SubDescr'] == 'Lawyer Name') {
            this.captionLawyer = val['SelectedValue'];
          }
          //  CourtNumber 
          if (val['MainDescr'].toUpperCase() == pagehead[2].toUpperCase() && val['SubDescr'] == 'Court Number') {
            this.captionCourtNumber = val['SelectedValue'];
          }
          // Currency
          if (val['MainDescr'].toUpperCase() == pagehead[2].toUpperCase() && val['SubDescr'] == 'Currency') {
            this.captionCurrency = val['SelectedValue'];
          }
          //  Recovery Amount
          if (val['MainDescr'].toUpperCase() == pagehead[2].toUpperCase() && val['SubDescr'] == 'Recovery Amount') {
            this.captionRecoveryAmount = val['SelectedValue'];
          }
          //  Negotiate Amount 
          if (val['MainDescr'].toUpperCase() == pagehead[2].toUpperCase() && val['SubDescr'] == 'Negotiate Amount') {
            this.captionNegotiateAmount = val['SelectedValue'];
          }
          // Balance Amount 
          if (val['MainDescr'].toUpperCase() == pagehead[2].toUpperCase() && val['SubDescr'] == 'Balance Amount') {
            this.captionBalanceAmount = val['SelectedValue'];
          }
          // FIR Date
          if (val['MainDescr'].toUpperCase() == pagehead[2].toUpperCase() && val['SubDescr'] == 'FIR Date') {
            this.captionFIRDate = val['SelectedValue'];
          }
          //  Agency
          if (val['MainDescr'].toUpperCase() == pagehead[2].toUpperCase() && val['SubDescr'] == 'Agency') {
            this.captionAgency = val['SelectedValue'];
          }
          // Filing Party
          if (val['MainDescr'].toUpperCase() == pagehead[2].toUpperCase() && val['SubDescr'] == 'Filing Party') {
            this.captionFilingParty = val['SelectedValue'];
          }
          // Opposite Party
          if (val['MainDescr'].toUpperCase() == pagehead[2].toUpperCase() && val['SubDescr'] == 'Opposite Party') {
            this.captionOppositeParty = val['SelectedValue'];
          }

        }
      }
      );
 }
    // function f() for display validation on header part
    get f() { return this.addFormNotice.controls; }

  getMasterData() {
    /********** For Get Contact Manager Name ****** */
      this.http.get(this.url + 'GM/GetEmployee') .subscribe( (data) => {
      this.Manager = JSON.parse(data.toString()); });
  }
  getSysData(GID: string) {
    return this.http.get(this.url + 'SysData/GetSysData?GenID=' + GID )
    .pipe(map(data => data = (data == null ? null : JSON.parse(data.toString()))));
    }
  // For Bind Field on Page Load Like Company, Department, State, Agency, City
  getMaster(GID: string, MID: string) {
    return this.http.get(this.url + 'GM/GetMaster?GenID=' + GID + '&MainID=' + MID)
    .pipe(map(data => data = (data == null ? null : JSON.parse(data.toString()))));
    }
    fetchNoticeCaseData() {
      this.http.get(this.url + 'Notice/Fetch_Existing_Mandatory_Notice_Case?ID=' + this.id)
      .subscribe( (data) =>   {
          if (data == null) {
            this.NoticeCaseData = null;
          } else {
            const fetchHeaderdata: Insertnoticecase = JSON.parse(data.toString())[0];
            this.FetchFillingOppositePartyList();
            if (fetchHeaderdata.fillingPartyName != null  ) {
              this.selectedFillingParty = fetchHeaderdata.fillingPartyName.toString().split(',').map(Number); }
            if (fetchHeaderdata.OppositePartyName != null  ) {
                this.selectedOppositeParty = fetchHeaderdata.OppositePartyName.toString().split(',').map(Number); }
            this.ManagerPreID = fetchHeaderdata.ManagerID == null ? 0 : fetchHeaderdata.ManagerID;
            this.LeaderPreID = fetchHeaderdata.LeaderID == null ? 0 : fetchHeaderdata.LeaderID;
            this.addFormNotice.patchValue({
              Manager: fetchHeaderdata.ManagerID == null ? 0 : fetchHeaderdata.ManagerID,
              DateofNotice: fetchHeaderdata.NoticeDt, Notice: fetchHeaderdata.IsSent == false ? "0" : "1",
              RefNo: fetchHeaderdata.refno, TargetDate: fetchHeaderdata.TargetDt == null ? "" : fetchHeaderdata.TargetDt,
              Leader: fetchHeaderdata.LeaderID == null ? 0 : fetchHeaderdata.LeaderID,
              DueDate: fetchHeaderdata.DueDt == null ? "" : fetchHeaderdata.DueDt
            });
          }
         }
      );
    }

FetchFillingOppositePartyList() {
  this.http.get(this.url + 'Help/FetchHelpFillingOpposite')
    .subscribe( (data) =>   {
        if (data == null) {
          this.FillingOppoParty = null;
        } else {
          this.FillingOppoParty = JSON.parse(data.toString());
          this.filteredFillingParty = [...this.FillingOppoParty];
          this.filteredOppositeParty = [...this.FillingOppoParty];
        }
       }
    );
}

// Save Notice or  Case
onHeaderSubmit(HearderFormData) {
   if (this.addFormNotice.invalid) {
    this.addFormNotice.markAllAsTouched();
    return;
  }
  if (HearderFormData.RefNo == "") {
    this.alertService.showWarning("Please Enter Refno");
    // this.alertService.warn(" Please Enter Refno",this.options);
     return; }
  if (HearderFormData.Manager == "0") {
    this.alertService.showWarning("Please Select Manager");
    // this.alertService.warn("Please Select Manager",this. options);
    return; }
   if (this.datepipe.transform(HearderFormData.DueDate,"yyyy-MM-dd")< this.datepipe.transform(HearderFormData.TargetDate,"yyyy-MM-dd")) { this.alertService.showError("Select Due Date greater or equal to Target Date"); return;} 
   if (this.datepipe.transform(HearderFormData.TargetDate,"yyyy-MM-dd")< this.datepipe.transform(HearderFormData.DateofNotice,"yyyy-MM-dd")) { this.alertService.showError("Select Target Date greater or equal to Date of Notice"); return;}
  if (HearderFormData.Leader == "0"){
    this.alertService.warn("Please Select Leader",this. options);
     return; }
  if (HearderFormData.fillingPartyName.length == 0) {
    this.alertService.warn("Please Select Filling Party",this. options);
     return; }
  if (HearderFormData.OppositePartyName.length == 0) {
    this.alertService.warn("Please Select Opposite Party",this. options);
       return; }
  if (this.addFormNotice.invalid) { return; }

  if (HearderFormData.Notice == "") {

  if (this.Type == "Notice") {
    this.alertService.showWarning("Please Select Notice Type Received or Sent");
    // this.alertService.warn("Please Select Notice Type Received or Sent",this. options);
  } else {
    this.alertService.showWarning("Please Select Case Type Filled By Us or Against Us");
    // this.alertService.warn("Please Select Case Type Filled By Us or Against Us",this. options);
  }
  return;
      } else {
       this.numb = 1;
       let noticeobj: Insertnoticecase = {
        id: this.id,
        refno: HearderFormData.RefNo,
        Type: this.Type,
        IsSent: HearderFormData.Notice,
        NoticeDt: HearderFormData.DateofNotice,
        TargetDt: HearderFormData.TargetDate,
        DueDt: HearderFormData.DueDate,
        ManagerID: HearderFormData.Manager,
        LeaderID: HearderFormData.Leader,
        recEnable: this.numb,
        recUser: this.numb,
        recAddUser: this.numb,
        fillingPartyName: HearderFormData.fillingPartyName.toString(),
        OppositePartyName: HearderFormData.OppositePartyName.toString(),
        ManagerPreID: this.ManagerPreID,
        LeaderPreID: this.LeaderPreID
       };
       this.http.post(this.url + 'Notice/InsertUpdateNoticeMandatory', noticeobj) .subscribe( (data) => {
         this.clicked = false;
         if (data == null) {
          this.alertService.showError("Some Error In Entered Record");
          // this.alertService.error("Some Error In Entered Record",true);
        } else {
          this.LeaderPreID = HearderFormData.Leader;
          this.ManagerPreID = HearderFormData.Manager;
          if (this.id == 0 ) {
            this.alertService.showSuccess(this.TypeHeader+" Add Successfully");
            // this.alertService.success(this.TypeHeader+" Add Successfully",this. options);
          } else {
            this.alertService.showSuccess(this.TypeHeader+" Updated Successfully");
            // this.alertService.success(this.TypeHeader+" Updated Successfully",this. options);
          }
                 data = data.toString().split(':');
                 this.getdata = data[1].toString().split('}');
                 this.id = this.getdata[0].toString();
                 this.HeaderButtonCaption = "Update" ;
                 this.DisplayExistNotice = "" ;
                 this.DisplaySaveNoticeButton = "submit" ;
                 //if (confirm('Do you want to fill further details?')) {
                   if(HearderFormData.Leader != "0" && HearderFormData.fillingPartyName != "" && HearderFormData.OppositePartyName != "")
                 window.location.href = "gnotice/"+this.TypeHeader+"/" + this.getdata[0].toString();
                //}
              }
           }
         );
        }
  }

  goBack(){
    window.history.back();
  }
    updateFilters() {
    // Remove opposite party selections from filling party list
    this.filteredFillingParty = this.FillingOppoParty.filter(
      item => !this.selectedOppositeParty?.includes(item.ID)
    );

    // Remove filling party selections from opposite party list
    this.filteredOppositeParty = this.FillingOppoParty.filter(
      item => !this.selectedFillingParty?.includes(item.ID)
    );
  }
}
